<script>
import baseMixin from '@/mixins/baseMixin'
import FileList from './file-list.vue'
import FilePreviewGalleryDialog from './file-preview-gallery-dialog.vue'

export default {
  name: 'FileListWithPreviewGallery',
  components: { FileList, FilePreviewGalleryDialog },
  mixins: [baseMixin],
  props: {
    files: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
    },
    downloadHandler: {
      type: Function,
      default: function () {
        return null
      },
    },
    downloadHandlerPayload: {
      type: Object,
      default: () => null,
    },
    disableDownload: {
      type: Boolean,
    },
    hideLabel: {
      type: Boolean,
    },
    showNoFilesBlock: {
      type: Boolean,
    },
  },
  data: () => {
    return {
      viewFile: false,
      preselectFile: 0,
      selectedFile: null,
      selectedFileTitle: '',
      isLoadingViewer: false,
    }
  },
  methods: {
    async downloadFile(objectId) {
      // retrieve file
      this.selectedFile = this.files.find((file) => file.id === objectId)
      this.selectedFileTitle = this.selectedFile.name
      // files not retrieved will be downloaded
      if (!this.selectedFile.file) {
        const payload = {
          ...this.downloadHandlerPayload,
          accessGui: this.selectedFile.accessGuid,
        }

        const result = await this.downloadHandler(payload)
        if (result.isSuccess) this.selectedFile.file = result.data
      }

      this.viewFile = true
    },
    openFilePreviewGallery(fileId) {
      const index = this.files.findIndex((file) => file.id === fileId)
      this.preselectFile = index < 0 ? 0 : index
      this.viewFile = true
    },
    async retryDownload() {
      this.isLoadingViewer = true
      await this.downloadFile(this.selectedFile.id)
      this.isLoadingViewer = false
    },
    removeFile(objectId) {
      this.$emit('removeFile', objectId)
    },
  },
}
</script>

<template>
  <div>
    <FileList
      :files="files"
      :disable-download="disableDownload"
      :read-only="readOnly"
      :hide-label="hideLabel"
      :show-no-files-block="showNoFilesBlock"
      @viewFile="openFilePreviewGallery"
      @removeFile="removeFile"
    />
    <FilePreviewGalleryDialog
      v-model="viewFile"
      :files="files"
      :preselect="preselectFile"
      :download-handler="downloadFile"
      @retry="retryDownload"
    />
  </div>
</template>
